import { Component, Prop } from 'vue-property-decorator';
import * as tsx from 'vue-tsx-support';
import log from '@/utils/log';

const marked = 'V'
const routerNames = {
  signin: 1,
  signup: 2,
  forgotpassword: 3,
  bindPhoneNumber: 4,
  home: 5,
  devicePlay: 6,
  order: 7,
  message: 8,
  result: 9,
  package: 10,
  customer: 11,
  confirmOrder: 12,
  activity: 13,
  404: 14
}

interface ILog {
  type?: 'hooks' | 'event' | 'quit';
  number?: string | number;
  pageName?: string,
  trackId?: string | number
}

@Component
export default class Log extends tsx.Component<ILog> {
  
  @Prop({default: 'event'}) public type?: 'hooks' | 'event' | 'quit'
  @Prop() public number?: string | number;
  @Prop() public pageName?: string
  @Prop() public trackId?:  string | number
  async mounted () {
    await log.stitching({})
    if (this.$props.type === 'hooks') {
      await log.logRequest({eventId: this.$props.number})
    }
  }
  
  async beforeDestroy () {
    if (this.$props.type === 'quit') {
      await log.logRequest({eventId: this.$props.number})
    }
  }
  
  async eventRequest () {
    console.log(this.$props.trackId);
    if (this.$props.type === 'event') {
     await log.logRequest({eventId: this.$props.number,trackId: this.$props.trackId})
    }
  }
  
  render() {
    return (
      <div onClick={this.eventRequest} >
        {this.$slots.default}
      </div>
    )
  }
  
}